/* eslint-disable indent */
import { logError } from '@log';
import { request } from './request';
import {
  // MOCK_LOGIN_RESP,
  // MOCK_GET_RA_REASON,
  // MOCK_RA_ITEMS,
  // MOCK_DHGATE_ITEMS,
} from './mock';

const loginApi = 'query-related-claims';

/**
 * 登陆
 * @param {String} email 邮箱地址
 * @param {String} orderNumber 订单id
 */
export const estimateClaim = async ({
  email, orderNumber, policyType, channel, path, headers, signature,
}) => {
  try {
    if (!email && !orderNumber) {
      logError(new Error(`Empty email or orderNumber, email=${email}, orderNumber=${orderNumber}`));
      return null;
    }
    const resp = await request(loginApi, {
      body: {
        email,
        orderNumber,
        policyType,
        channel,
        signature,
      },
      path,
      headers,
    });
    // console.log('query-related-claims 入参(登录)', {
    //   email, orderNumber, policyType, channel, headers,
    // });
    // const resp = MOCK_LOGIN_RESP(orderNumber);
    if (!resp) {
      logError(new Error(`${loginApi} no resp`));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};

/**
 * 根据保单获取包裹数据
//  * @param {String} email 邮箱地址
//  * @param {String} policyId 保单 id
 */
// export const getPackage = async (email, policyId) => {
//   try {
//     if (!email || !policyId) {
//       logError(new Error('error'));
//       return null;
//     }
//     // const resp = await request('estimate-jing-claim-request', {
//     //   body: {
//     //     email,
//     //     policyId,
//     //   },
//     // });
//     console.log('estimate-jing-claim-request', { email, policyId });
//     const resp = MOCK_ESTIMATE_RESP;
//     if (!resp) {
//       logError(new Error(`${TAG} getPackage no resp`));
//       return null;
//     }
//     return resp;
//   } catch (error) {
//     logError(error);
//     return null;
//   }
// };

export const getRAReason = async (policyId) => {
  try {
    const resp = await request('get-claim-reason', {
      body: {
        policyId,
      },
    });
    return resp;
  } catch (err) {
    logError(err);
    return null;
  }
};
export const getPackage = async ({ path, headers, ...body }) => {
  try {
    const resp = await request('get-protected-items', {
      body,
      path,
      headers,
    });
    // console.log('get_protected-items入参', body);
    // const resp = MOCK_DHGATE_ITEMS;
    if (!resp) {
      logError(new Error('get_protected-items no resp'));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};
